import { getSelfProfileForSubscriptionsAction } from '@/entities/subscriptions';
import { SubscriptionsResponseV1 } from '@/shared/api';

import { SubscriptionsItem } from './subscriptions-item';

export type SubscriptionsListProps = {
	data: SubscriptionsResponseV1;
	promocode?: string;
	isPromoCodeValid?: boolean;
};

export async function SubscriptionsList({
	data,
	isPromoCodeValid,
	promocode,
}: SubscriptionsListProps) {
	const { productsID } = await getSelfProfileForSubscriptionsAction();

	const visibleItems = data.filter((item) => {
		// Скрываем тариф, если пользователь уже имеет эту подписку
		if (productsID.includes(item.subscriptionId)) {
			return false;
		}
		// У пользователя есть активный премиум и этот тариф нельзя купить с активным премиумом
		if (productsID.length > 0 && !item.canBeBoughtWithActivePremium) {
			return false;
		}
		return true;
	});

	if (visibleItems.length === 0) {
		return null;
	}

	return (
		<div
			id="subscriptions"
			className="flex flex-col items-center gap-6 md:gap-6 lg:flex-row lg:items-stretch lg:justify-center"
		>
			{visibleItems.map((item) => (
				<div key={item.subscriptionId} className="max-w-lg lg:w-1/3">
					<SubscriptionsItem
						data={item}
						promocode={promocode}
						isPromoCodeValid={isPromoCodeValid}
					/>
				</div>
			))}
		</div>
	);
}
